import { SubscriptionFeature } from "../../types/billing/SubscriptionFeature";

export const bankImApRequiredFeatures = [
    SubscriptionFeature.DealerProfileEmailAlerts,
    SubscriptionFeature.IssuanceMonitorFullAccess,
];
